import React from "react";
import Hero from "../components/Career/Hero";
import Grow from "../components/Career/Grow";
import Vacancies from "../components/Career/Vacancies";
import Digital from "../components/Service/Digital";
import OurClients from "../components/Home/OurClients";

const Career = () => {
  return (
    <div className="container mx-auto">
      <Hero />
      <Grow />
      <Vacancies />
      <Digital />
      <OurClients />
    </div>
  );
};

export default Career;
